module.exports = __webpack_public_path__ + "img/fopeaVacaMuerta.da834662.jpg";